<template>
    <div class="box">
        <Box title="合同详情">
            <div class="tabs">
                <div v-for="(item, index) in ['合同信息','设备信息','付款管理','合同附件']" :class="selectIndex === index ? 'action' : ''"
                    @click="selectIndex = index">{{item}}</div>
            </div>
            <div class="contentBox">
                <div class="firstBox" key="firstBox" v-if="selectIndex === 0">
                    <Field title='合同编号' type='text' :text='data.HTBH' />
                    <Field title='合同名称' type='text' :text='data.HTMC' />
                    <Field title='合同类型' type='text' :text='data.HTLXMC' />
                    <Field title='合同金额' type='text' :text='data.HTJE' />
                    <Field title='合同类型' type='text' :text='data.TBBZMC' />
                    <Field title='录入人' type='text' :text='data.LRRMC' />
                    <Field title='录入时间' type='text' :text='data.MakeTime' />
                    <Field title='甲方科室' type='text' :text='data.JFKS' />
                    <Field title='乙方联系人' type='text' :text='data.QYLXR' />
                    <Field title='乙方电话' type='text' :text='data.QYLXDH' />
                    <Field title='维修单位' type='text' :text='data.WXDWMC' />
                    <Field title='维保到期' type='text' :text='data.YXRQ' />
                    <Field title='资金来源' type='text' :text='data.ZJLYMC' />
                </div>
            </div>
            <div v-if="selectIndex===1">
                <van-cell-group v-for="(item,index) in dataDefaultList" :key='index' @click="show=true,dataDefault=item">
                    <van-cell>
                        <template slot="title">
                            <div class="spanClassEeuipment first_Span">
                               <div>
                                    <span>{{index+1}}</span>
                               </div>
                               <div><img src="../../assets/img/right.png" /></div>
                            </div>
                        </template>
                    </van-cell>
                    <van-cell title="设备名称" :value="item.SBMC" />
                    <van-cell title="规格型号" :value="item.GGXH" />
                    <van-cell title="数量" :value="item.SL" />
                    <van-cell title="单价" :value="item.DJ+'￥'" />
                </van-cell-group>
                <!--设备弹出层-->
                <van-popup v-model="show" position="bottom" round :style="{width:'100%'}">
                    <div>
                        <div>
                            <van-cell title="设备编号" :value="dataDefault.SBBH" />
                            <van-cell title="规格型号" :value="dataDefault.GGXH" />
                            <van-cell title="数量" :value="dataDefault.SL" />
                            <van-cell title="单价" :value="dataDefault.DJ+'￥'" />
                            <van-cell title="金额" :value="dataDefault.JE+'￥'" />
                            <van-cell title="品牌" :value="dataDefault.PPMC" />
                            <van-cell title="国别" :value="dataDefault.GBMC" />
                            <van-cell title="产地" :value="dataDefault.CDMC" />
                            <van-cell title="是否国产" :value="dataDefault.ISDomesticMC" />
                        </div>
                    </div>
                </van-popup>
            </div>
            <div v-if="selectIndex===2">
                <van-cell-group v-for="(item,index) in payDefaultList" :key='index' @click='show=true,dataDefault=item'>
                    <van-cell>
                        <template slot="title">
                            <div class="spanClassEeuipment">
                                <div><span>{{item._je}}￥</span></div>
                                <div><img src="../../assets/img/right.png" /></div>
                            </div>

                        </template>
                    </van-cell>
                    <van-cell title="付款名称" :value="item._name" />
                    <van-cell title="预计付款日期" :value="$format(item._yjfkrq,'YYYY-MM-DD')" />
                </van-cell-group>

                <van-popup v-model="show" position="bottom" round :style="{width:'100%'}">
                    <van-cell title="付款日期" :value="dataDefault._fkrq!='1900-01-01T00:00:00'?$format(dataDefault._fkrq,'YYYY-MM-DD'):'暂无'" />
                    <van-cell title="付款金额" :value="dataDefault._je+'￥'" />
                    <van-cell title="付款比例" :value="dataDefault._fkbl+'%'" />
                    <van-cell title="付款备注" :value="dataDefault._bz" />
                </van-popup>
            </div>
            <div v-if="selectIndex===3">
                <ImgModule upload :deletable="$UserInfo.RYLB==='2'" @afterRead="afterRead(arguments[0])" @deleteImg="deleteImg(arguments[0])"
                    :img="uploadImg" :disabled="!($UserInfo.RYLB==='2')"/>
                <van-cell-group v-for="(item,index) in document" :key='index'>
                    <van-cell title="文件名称" :value="item.FJMC" />
                    <van-cell title="文件类型" :value="(item.RePath.split('.'))[item.RePath.split('.').length-1]" />
                    <van-cell>
                        <template slot="title">
                            <div class="spanClass" @click="DownLoad(item)">
                                <span>下载</span>
                            </div>
                        </template>
                    </van-cell>
                </van-cell-group>
            </div>
        </Box>
    </div>
</template>

<script>
    import {
        Cell,
        CellGroup,
        ImagePreview,
        tag,
        Popup,
        Col,
        Row
    } from 'vant';
    import download from '../../../tool/download.js'
    import Box from '../../components/commonBox/commonBox'
    import ImgModule from '../../components/imgModule/imgModule'
    import Field from '../../components/field/field.vue'
    export default {
        name: 'Accessory',
        components: {
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [tag.name]: tag,
            [Popup.name]: Popup,
            [Col.name]: Col,
            [Row.name]: Row,
            Box,
            ImgModule,
            Field,
        },
        data() {
            return {
                show: false,
                data: {}, //合同信息
                dataDefaultList: [], //合同内容
                payDefaultList: [], //付款计划
                uploadImg: [], //  图片
                selectIndex: 0, //选项卡默认选中
                ImgTypeArray: ['png', 'jpg', 'jpeg', 'bmp', 'gif'],
                document: [],
                dataDefault: {},
            }
        },
        mounted() {
            this.loadDataDefault();
        },
        methods: {
            loadDataDefault() {
                this.$get('api/HT/GetContractDefault', {
                    HTBH: this.$route.params.item.HTBH
                }).then(result => {
                    if (!result.Status) {
                        this.$Toast('数据异常,请联系管理员!');
                        return false;
                    }
                    result.HTGL_JBXX.length !== 0 ? this.data = result.HTGL_JBXX[0] : '';
                    this.dataDefaultList = result.HTGL_JBXX_DT;
                    this.payDefaultList = result.HTFKInfo;
                    for (let i = 0; i < result.ZZGL_HTGL_FJB.length; i++) {
                        var pathArray = result.ZZGL_HTGL_FJB[i].RePath.split('.');
                        if (this.ImgTypeArray.findIndex(x => x === pathArray[pathArray.length - 1]) !== -1) {
                            this.uploadImg.push({
                                FJLJ:result.ZZGL_HTGL_FJB[i].FJLJ,
                                HH:result.ZZGL_HTGL_FJB[i].HH,
                                url: result.ZZGL_HTGL_FJB[i].RePath,
                            })
                        } else {
                            this.document.push(result.ZZGL_HTGL_FJB[i]);
                        };

                    }

                })
            },
            afterRead(value) {
                let data = {};
                value instanceof Array ? data = {
                    base64Str1: 1 <= value.length ? value[0].content : '',
                    base64Str2: 2 <= value.length ? value[1].content : '',
                    base64Str3: 3 <= value.length ? value[2].content : '',
                    base64Str4: 4 <= value.length ? value[3].content : '',
                    base64Str5: 5 <= value.length ? value[4].content : '',
                    base64Str6: 6 <= value.length ? value[5].content : '',
                    base64Str7: 7 <= value.length ? value[6].content : '',
                    base64Str8: 8 <= value.length ? value[7].content : '',
                    base64Str9: 9 <= value.length ? value[8].content : '',
                    base64Str10: 10 <= value.length ? value[9].content : '',
                    DocType: '',
                    UserId: this.$UserInfo.UserId,
                    HTBH: this.$route.params.item.HTBH
                } : data = {
                    base64Str1: value.content,
                    DocType: '',
                    UserId: this.$UserInfo.UserId,
                    HTBH: this.$route.params.item.HTBH
                };
                this.$post('api/HT/UploadImage', data,{timeout:100000}).then(result=>{
                    if(result.Status){
                        this.$Toast('上传成功!');
                        setTimeout(x=>{
                            this.loadImage();
                        },1000);
                    }else this.$Toast('上传失败!');
                });
            },
            deleteImg(value) {
                this.$Dialog.confirm({
                    message: '确认删除？'
                }).then(() => {
                    this.$post('api/HT/DelHTTP', {
                        HTBH: this.$route.params.item.HTBH,
                        HH: value.HH,
                        FJLJ: value.FJLJ
                    }).then(result => {
                        if (result.Status)
                            {
                                this.$Toast('删除成功!');
                                this.uploadImg.splice(this.uploadImg.findIndex(x=>x.HH===value.HH),1);
                            }
                        else
                            this.$Toast('删除失败!');
                    });
                }).catch(() => {});
            },
            DownLoad(item) {
                try {
                    this.$Toast.loading({
                        message: '正在下载',
                        forbidClick: true,
                        duration: 1000
                    });
                    download('api' + item.FJLJ);
                } catch (e) {
                    this.$Toast('数据异常');
                }
            },loadImage(){
                this.uploadImg = [];
                this.$get('api/HT/GetTPByHTBH', {
                    Store: this.$UserInfo.StoreCode,
                    HTBH: this.$route.params.item.HTBH
                }).then(result => {
                    this.uploadImg=[];
                    let that=this;
                    result.HTTPList.map(e => !!e.URL && that.uploadImg.push({
                        url: e.URL,
                        FJLJ: e.FJLJ,
                        HH:e.HH
                    }));
                   this.$Bus.$emit('YSRKDelete', this.uploadImg);
                });
            }
        }
    }
</script>
<style scoped lang="scss">
    .equipment {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 34px 40px 20px;
        box-sizing: border-box;
        margin-bottom: 20px;

        .title {
            color: $TEXT-DARK-COLOR;
            font-size: 34px;
            font-weight: bold;
            margin-bottom: 30px;
        }

        img {
            width: 150px;
            height: 192px;
        }

        .equipment-details {
            display: flex;
            margin-top: 24px;

            &>div {
                margin-left: 34px;
                display: flex;

                div {
                    &:first-child {
                        color: #999;
                        line-height: 55px;
                    }

                    &:last-child {
                        color: #333;
                        line-height: 55px;

                        p {
                            width: 280px;
                            font-size: 29px;
                            color: #333;
                        }
                    }
                }
            }
        }
    }

    .tabs {
        display: flex;
        align-items: center;
        background: #45918A;
        border-radius: 14px 14px 0 0;
        position: fixed;
        z-index: 10;
        top: 105px;

        div {
            width: 177.5px;
            height: 96px;
            text-align: center;
            line-height: 96px;
            font-size: 28px;
            color: rgba(255, 255, 255, .7);
            border-radius: 14px 14px 0 0;
        }

        .action {
            color: $THEME-COLOR;
            background: #fff;
        }
    }

    .contentBox {
        margin-top: 85px;

        &>div {
            padding: 0 30px;
            border-radius: 14px;
            background: #fff;
            margin-bottom: 30px;

            &:first-child {
                border-radius: 14px;
            }
        }
    }

    .van-cell-group {
        margin-top: 10px;

        span {
            color: #14171a;
            font-size: 4vw;
        }
    }

    .spanClass {
        float: right;
        width: 100px;
        background: #4FA69E;
        border-radius: 1em;

        span {
            margin-left: 20px;
            color: #FFFFFF;
        }
    }


    .spanClassEeuipment {
        &>div{
            &:first-child{
                float: left;
                background: #FF9E48;
                border-radius: 1em;

                span {
                    color: #FFFFFF;
                }
            }
            &:last-child{
                img{
                    width: 40px;
                    height: 40px;
                    float:right;
                }
            }
        }
    }
    .first_Span{
        &>div{
            &:first-child{
                background: #48A4FF;
            }
        }
    }
    .incoice {
        position: relative;
        top: 50%;
        margin-top: -7%;
        text-align: center;
        padding: 0 20px;

        &>div {
            &:first-child {
                span {
                    color: #4FA69E;
                    display: inline-block;
                    width: 40%;
                }

                p {
                    text-align: left;
                    display: inline-block;
                    width: 60%;
                }
            }

            &:last-child {
                margin-top: 10px;

                span {
                    display: inline-block;
                    width: 40%;
                }

                p {
                    text-align: left;
                    width: 60%;
                    display: inline-block;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/accessory/accessory.vue